<template>
  <div class="container">
    <van-nav-bar title="项目列表" left-text="" 
      left-arrow @click-left="onClickLeft"  @click-right="onClickRight">
      <template #right>
        <van-icon name="search" size="18" />
      </template>
    </van-nav-bar>
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="projectList.length > 0?'没有更多了':'暂无数据'"
      @load="onLoad"
    >
      <div class="list-box">
        <div class="list" :key="index" v-for="(item,index) in projectList" @click="viewchange(item,1)">
          <div class="clearfix">
            <div class="bold mg10">{{item.communityName}}</div>
            <div class="list-left fl_left">
              <div class="mg10">姓名：{{item.contact}}</div>
              <div class="mg10">电话：{{item.mobile}}</div>
              
            </div>
            <div class="list-right fl_right">
              <a class="tel" :href="'tel:'+item.mobile">
                <img src="../assets/img/phone.png" alt="">
              </a>
            </div>
          </div>
          <div class="mg10">地址：{{item.address}}</div>
          
          <div>
            <div class="mg10 flex">
              <span class="labs" @click.stop="changePage(0,item.communityId)">设备总数 <span class="blod">{{item.deviceStatistic.total}}</span></span>
              <span class="labs" @click.stop="changePage(1,item.communityId)">设备在线 <span class="blod">{{item.deviceStatistic.onlines}}</span></span>
              <span class="labs" @click.stop="changePage(2,item.communityId)">设备离线 <span class="blod">{{item.deviceStatistic.offlines}}</span></span>
            </div>
            <div class="flex">
              <span class="labs" @click.stop="changePage(3,item.communityId)">设备禁用 <span class="blod">{{item.deviceStatistic.unInstalls}}</span></span>
              <span class="labs" >今日充值 <span class="blod">{{item.todayRecharges}}元</span></span>
              <span class="labs">总用户数 <span class="blod">{{item.totalHouse}}</span></span>
            </div>
          </div>
        </div>
        
      </div>
    </van-list>  
    <!-- <div class="noData" v-if="projectList.length == 0">暂无数据</div> -->
    <div class="btnbox" v-if="userInfo.type == 1">
      <van-button type="info" size="large" @click="viewchange('','')">添加项目</van-button>
    </div>
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Loading,List,Button} from 'vant';
  export default {
    data() {
      return {
        keyword:'',
        allCount:0,
        pageIndex:1,
        pageSize:10,
        loading: false,
        finished:false,
        projectList:[],
        userInfo:'',
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Loading.name]:Loading,
      [List.name]:List,
      [Button.name]:Button,
    },
    methods: {
      changePage(val,id){
        this.$router.push({path: "deviceList.html",query:{tab_active:val,communityId:id,isPro:1}})
      },
      viewchange(item,readonly){
        this.$router.push({path: "projectDetail.html",query:{communityId:item.communityId,readonly:readonly}})
      },
      onLoad(){
        // 异步更新数据
        setTimeout(()=>{
          this.pageIndex++;
          this.getMoreList();
        },500)
      },
      getUserInfo() {
        axios.get("/auth/getuserinfo",{
        }).then((res)=>{
          this.userInfo = res.data;
        })
      },
      getProjectList() {
        axios.post("/community/pagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            communityIds: [],
            cityCode: ""
          }
        }).then((res)=>{
          this.projectList = res.data.list;
          this.allCount = res.data.total;
        })
      },
      getMoreList() {
        axios.post("/community/pagelist",{
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          filter: {
            keyword: this.keyword,
            communityIds: [],
            cityCode: ""
          }
        }).then((res)=>{
          this.projectList = this.projectList.concat(res.data.list);
          this.allCount = res.data.total;
          // 加载状态结束
          this.loading = false;
          // 数据全部加载完成
          if (this.pageIndex * this.pageSize >= this.allCount) {
            this.finished = true;
          }
        })
      },
      onClickLeft() {
        this.$router.replace({path: "home.html"});
      },
      onClickRight() {
        this.$router.push({path: "search.html",query:{pageType: 1}});
      },
    },
    computed:{
    },
    created () {
      this.getUserInfo();
      this.keyword = this.$route.query.keyword;
      this.getProjectList();  
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;padding-bottom: 90px;
  }
  .list-box{
    width: 100%;
    color: #373737;
    .list{
      font-size: 14px;
      width: 100%;
      background: #fff;
      margin: 12px 0;
      padding: 12px;
      .list-left{
        width: 80%;
        .name{width: 140px;display: inline-block;}
      }
      .list-right{
        width: 20%;
        text-align: right;
        img{
          width: 40px;
          margin-top: 10px;
        }
      }
    }
    .fg{
      width: 2px;
      height: 16px;
      display: inline-block;
      background: #7BC9FF;
      // margin: 0 20px;
      vertical-align: middle;
    }
    .labs{
      
    }
    .mg10{margin-bottom: 10px;}
    .bold{font-weight: bold;}
  }
  .noData{
    color: #969799;
    font-size: 14px;
    line-height: 50px;
    text-align: center;
  }
  .width300{width: 300px;}
  .btnbox{
    width: 100%;
    background: #fff;
    position: fixed;
    left: 0;
    bottom: 0;
    margin-top: 50px;
    padding: 16px 50px;
  }
</style>
